import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { auditTime, distinctUntilChanged } from 'rxjs/operators';
import { fetchSettings } from 'src/main';

@Injectable({
  providedIn: 'root',
})
export class StoreDebugService {
  constructor(private store: Store<any>) {
    this.monitorState();
  }

  private async monitorState() {
    const config = await fetchSettings();

    if (!config.production) {
      this.store.subscribe((state) => {
        console.groupCollapsed('%c📦 State', 'font-weight: bold');
        console.log(state);
        console.groupEnd();
      });
    }
  }
}
